import { BUTTON_CELL_SCHEVRON_OPTION_DISPLAY_NAME } from "./core";
import createDisplayName from "../../../../fabrics/createDisplayName";

export const createDisplayNameForButtonCellSchevronElement = createDisplayName(
    BUTTON_CELL_SCHEVRON_OPTION_DISPLAY_NAME,
);
